import {Language} from "./language/Language.ts";

export type CpacStoreState = {
    lang: Language
    timezone: string
    localeStrings: Map<string, string>
}

const createStore = (initialState: CpacStoreState) => {
    let currentState: CpacStoreState = initialState
    const listeners = new Set<(callback: CpacStoreState) => void>()
    return {
        getState: () => {
            return currentState
        },
        subscribe: (listener: (callback: CpacStoreState) => void) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        setLanguage: (value: Language) => {
            currentState = {...currentState, lang: value};
            listeners.forEach((listener) => listener(currentState))
        },
        setTimezone: (value: string) => {
            currentState = {...currentState, timezone: value};
            listeners.forEach((listener) => listener(currentState))
        },
        setLocaleStrings: (value: Map<string, string>) => {
            currentState = {...currentState, localeStrings: value};
            listeners.forEach((listener) => listener(currentState))
        }
    }
}

const store = createStore({
    lang: Language.en,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    localeStrings: new Map()
});

export default store;